import React from "react";
import {
  AUTH_PREFIX_PATH,
  APP_PREFIX_PATH,
  REDIRECT_COMPONENT_KEY,
} from "configs/AppConfig";
import * as routeKeys from "constants/RoutesKeys";

export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login")
    ),
  },
  {
    key: "forgot-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/forgot-password")
    ),
  },
  // {
  //   key: 'register',
  //   path: `${AUTH_PREFIX_PATH}/register`,
  //   component: React.lazy(() =>
  //     import('views/auth-views/authentication/register')
  //   )
  // },
];

export const protectedRoutes = [
  {
    key: "packages",
    isPage: true,
    path: `${APP_PREFIX_PATH}/dashboards/packages/*`,
    component: React.lazy(() => import("views/app-views/dashboards/packages")),
  },
  {
    key: "sub-admins",
    isPage: true,
    path: `${APP_PREFIX_PATH}/dashboards/sub-admins/*`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/sub-admins")
    ),
  },
  {
    key: "admin-role",
    isPage: true,
    path: `${APP_PREFIX_PATH}/dashboards/admin-role/*`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/admin-role")
    ),
  },
  {
    key: "subscribers",
    isPage: true,
    path: `${APP_PREFIX_PATH}/dashboards/subscribers/*`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/subscribers")
    ),
  },
  {
    key: "subscriberEmployee",
    isPage: true,
    path: `${APP_PREFIX_PATH}/dashboards/subscriber-employee/*`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/subscriber-employee")
    ),
  },
  // {
  //   key: "subscriber-settings",
  //   isPage: true,
  //   path: `${APP_PREFIX_PATH}/dashboards/subscriber-settings/*`,
  //   component: React.lazy(() =>
  //     import("views/app-views/dashboards/subscriber-settings")
  //   ),
  // },
  {
    key: "admin-settings",
    isPage: true,
    path: `${APP_PREFIX_PATH}/dashboards/settings/*`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/admin-settings")
    ),
  },
  {
    key: "clients",
    isPage: true,
    path: `${APP_PREFIX_PATH}/dashboards/clients/*`,
    component: React.lazy(() => import("views/app-views/dashboards/clients")),
  },
  {
    key: "designations",
    isPage: true,
    path: `${APP_PREFIX_PATH}/dashboards/designations/*`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/designations")
    ),
  },
  {
    key: "tax-category",
    isPage: true,
    path: `${APP_PREFIX_PATH}/dashboards/tax-category/*`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/tax-category")
    ),
  },
  {
    key: "templates",
    isPage: true,
    path: `${APP_PREFIX_PATH}/dashboards/templates/*`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/templates-page")
    ),
  },
  {
    key: "notifications",
    isPage: true,
    path: `${APP_PREFIX_PATH}/dashboards/notifications/*`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/notifications")
    ),
  },
  {
    key: "pages.profile",
    isPage: true,
    path: `${APP_PREFIX_PATH}/pages/profile`,
    component: React.lazy(() => import("views/app-views/pages/profile")),
  },
  {
    key: "services",
    isPage: true,
    path: `${APP_PREFIX_PATH}/dashboards/services/*`,
    component: React.lazy(() => import("views/app-views/dashboards/services")),
  },
  {
    key: routeKeys.proformaInvoiceKey,
    isPage: true,
    path: `${APP_PREFIX_PATH}/dashboards/proforma-invoices/*`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/proforma-invoices")
    ),
  },
  {
    key: "items",
    isPage: true,
    path: `${APP_PREFIX_PATH}/dashboards/items/*`,
    component: React.lazy(() => import("views/app-views/dashboards/items")),
  },
  {
    key: routeKeys.enquiryKey,
    isPage: true,
    path: `${APP_PREFIX_PATH}/dashboards/enquiry/*`,
    component: React.lazy(() => import("views/app-views/dashboards/enquiry")),
  },
  {
    key: routeKeys.categoryKey,
    isPage: true,
    path: `${APP_PREFIX_PATH}/dashboards/category/*`,
    component: React.lazy(() => import("views/app-views/dashboards/category")),
  },
  {
    key: routeKeys.projectKey,
    isPage: true,
    path: `${APP_PREFIX_PATH}/dashboards/project/*`,
    component: React.lazy(() => import("views/app-views/dashboards/project")),
  },
  {
    key: routeKeys.expenseKey,
    isPage: true,
    path: `${APP_PREFIX_PATH}/dashboards/expense/*`,
    component: React.lazy(() => import("views/app-views/dashboards/expense")),
  },
  {
    key: routeKeys.projectCommentKey,
    isPage: true,
    path: `${APP_PREFIX_PATH}/dashboards/project-comments/*`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/project-comments")
    ),
  },
  {
    key: routeKeys.paymentKey,
    isPage: true,
    path: `${APP_PREFIX_PATH}/dashboards/payment/*`,
    component: React.lazy(() => import("views/app-views/dashboards/payment")),
  },
  {
    key: "transactions",
    isPage: true,
    path: `${APP_PREFIX_PATH}/dashboards/transactions/*`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/transactions")
    ),
  },
  {
    key: "comments",
    isPage: true,
    path: `${APP_PREFIX_PATH}/dashboards/comments/*`,
    component: React.lazy(() => import("views/app-views/dashboards/comments")),
  },
  {
    key: "subscriber-roles",
    isPage: true,
    path: `${APP_PREFIX_PATH}/dashboards/subscriber-roles/*`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/subscriber-role")
    ),
  },
  {
    key: "invoices",
    isPage: true,
    path: `${APP_PREFIX_PATH}/dashboards/invoices/*`,
    component: React.lazy(() => import("views/app-views/dashboards/invoices")),
  },
  {
    key: routeKeys.creditNotesKey,
    isPage: true,
    path: `${APP_PREFIX_PATH}/dashboards/credit-notes/*`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/credit-notes")
    ),
  },
  {
    key: "ledger",
    isPage: true,
    path: `${APP_PREFIX_PATH}/dashboards/ledgers/*`,
    component: React.lazy(() => import("views/app-views/dashboards/ledgers")),
  },
  {
    key: routeKeys.clientTypesKey,
    isPage: true,
    path: `${APP_PREFIX_PATH}/dashboards/client-types/*`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/client-types")
    ),
  },
];
